import { app } from '../../app.module'
/**
 * フォロワー数範囲フォーム
 * @class FollowerRangeFormCtrl
 */
class FollowerRangeFormCtrl {
  private snsType: string
  private followerRanges: {
    value: string
    name: string
  }[]
  private followerRange: string
  private onChange: Function
  private placeholder: string

  /**
   * 初期化イベント
   */
  public $onInit() {
    this.placeholder = 'フォロワー数(OR検索)'
    // フォロワー数範囲の初期化
    this.initFollowerRanges()
    // フォロワー数範囲をしている場合は、フォロワー数範囲を変更する
    if (this.followerRange) {
      this.changeFollowerRange()
    }
  }

  /**
   * フォロワー数範囲の変更
   */
  public changeFollowerRange() {
    if (typeof this.onChange === 'function') {
      if (!this.followerRange || this.followerRange.length === 0) {
        this.followerRange = null
      }
      this.onChange({ followerRange: this.followerRange })
    }
  }

  /**
   * フォロワー数範囲の初期化
   * @return {void}
   */
  private initFollowerRanges(): void {
    const followerRanges = [
      {
        value: '10000000',
        name: '1000万以上',
      },
      {
        value: '5000000-9999999',
        name: '500万 - 1000万',
      },
      {
        value: '1000000-4999999',
        name: '100万 - 500万',
      },
      {
        value: '500000-999999',
        name: '50万 - 100万',
      },
      {
        value: '100000-499999',
        name: '10万 - 50万',
      },
      {
        value: '50000-99999',
        name: '5万 - 10万',
      },
      {
        value: '10000-49999',
        name: '1万 - 5万',
      },
      {
        value: '5000-9999',
        name: '5千 - 1万',
      },
      {
        value: '1000-4999',
        name: '1千 - 5千',
      },
      {
        value: '0-999',
        name: '1千未満',
      },
    ]
    if (this.snsType === 'youtube') {
      followerRanges.push({
        value: '非公開',
        name: '非公開',
      })
    }
    this.followerRanges = followerRanges
  }
}

/**
 * フォロワー数範囲フォーム
 * attr: {string} snsType SNSタイプ
 * attr: {string} followerRange 選択しているフォロワー数範囲
 * attr: {function} onChange フォロワー数範囲の変更イベント
 */
app.component('followerRangeForm', {
  bindings: {
    snsType: '<',
    followerRange: '<',
    onChange: '&',
  },
  template: require('./follower-range-form.pug')(),
  controller: FollowerRangeFormCtrl,
})
